import React from 'react';
import ReusableDemoPage from "../ReusableDemoPage";
import { epikConfig } from '../demoConfigs';

const EpikDemo = () => {
  return <ReusableDemoPage config={epikConfig} />;
};

export default EpikDemo;